(() => {
  'use strict';
  function bindLanguagePicker() {
    const form = document.getElementById('ltm-language-form');
    const select = form?.querySelector('select[name="locale_code"]');
    if (!form || !select || form.dataset.ltmInstantLanguage === 'true') return;
    form.dataset.ltmInstantLanguage = 'true';

    function preservePage() {
      const url = new URL(location.href);
      // Published locales use native Shopify routes, never the old review helper.
      url.searchParams.delete('ltm_review_lang');
      const theme = window.Shopify?.theme;
      if (theme?.role === 'unpublished' && theme.id && !url.searchParams.has('preview_theme_id')) {
        url.searchParams.set('preview_theme_id', String(theme.id));
      }
      const returnTo = form.querySelector('input[name="return_to"]');
      if (returnTo) returnTo.value = url.pathname + url.search + url.hash;
    }

    form.addEventListener('submit', preservePage);
    select.addEventListener('change', () => {
      if (form.dataset.ltmSwitching === 'true') return;
      form.dataset.ltmSwitching = 'true';
      select.setAttribute('aria-busy', 'true');
      // Keep the select enabled so its chosen locale is included in the POST.
      preservePage();
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(form);
    });
    window.addEventListener('pageshow', event => {
      delete form.dataset.ltmSwitching;
      select.removeAttribute('aria-busy');
      if (event.persisted) {
        const current = [...select.options].find(option => option.defaultSelected);
        if (current) select.value = current.value;
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLanguagePicker, { once: true });
  } else bindLanguagePicker();
  document.addEventListener('shopify:section:load', bindLanguagePicker);
})();
